import { render, staticRenderFns } from "./ranking.vue?vue&type=template&id=3c2a9660&scoped=true"
import script from "./ranking.vue?vue&type=script&lang=js"
export * from "./ranking.vue?vue&type=script&lang=js"
import style0 from "./ranking.vue?vue&type=style&index=0&id=3c2a9660&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2a9660",
  null
  
)

export default component.exports